export default __webpack_public_path__ + "static/media/game2.bfd5260c.png";